const SET_SETTING = (state, data) => {
  state.setings = data.data;
};

const SET_EXAM_LIST = (state, data) => {
  state.examList = data.data;
};

const SET_EXAM_CATEGORY_LIST = (state, data) => {
  state.examCategoryList = data.data;
};

const SET_ARTICLE_LIST = (state, data) => {
  state.articleList = data.data;
};
export default {
  SET_SETTING,
  SET_EXAM_LIST,
  SET_EXAM_CATEGORY_LIST,
  SET_ARTICLE_LIST
};
